import { render, staticRenderFns } from "./UploadAutomatic.vue?vue&type=template&id=01c016d4"
import script from "./UploadAutomatic.vue?vue&type=script&lang=js"
export * from "./UploadAutomatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports